import React from 'react';
import {Text, View} from '@react-pdf/renderer';
import styles from '../styles';
import TickSvg from '../TickSvg';

export const CheckMark = ({selected, style = [], iconWidth = '8px'}) => (
  <View
    style={[
      styles.width5,
      styles.contentSection,
      styles.borderLeft,
      styles.center,
      ...style,
    ]}>
    {selected && <TickSvg width={iconWidth} />}
  </View>
);

export const ControlName = ({text}) => (
  <View style={[styles.width31, styles.sectionHeader, styles.verticalCenter]}>
    <Text style={styles.text}>{text}</Text>
  </View>
);

export const ControlItem = ({
  text,
  selected,
  style = [],
  noCheck,
  checkStyle,
  iconWidth,
}) => (
  <>
    <View style={[styles.borderLeft, styles.contentSection, ...style]}>
      <Text style={styles.text}>{text}</Text>
    </View>
    {!noCheck && (
      <CheckMark selected={selected} style={checkStyle} iconWidth={iconWidth} />
    )}
  </>
);
